<template>
  <div
    class="liveMatchesTwoPlayerClass"
    @mouseover="alwaysShow"
    @mousemove="onMousemove"
    @mouseout="toggleControl"
  >
    <div
      class="player-main"
      style="height: 100%"
      :class="{ fixed: full }"
      id="fullscreen"
      v-show="showBoxFlag"
    >
      <div class="player-load" v-if="detail && detail.status == 1">
        <!-- 正在加载 -->
        <div class="player-loading" v-if="loadingFlag">
          <!-- <img class="loading-logo" src="./img/logo.png" alt="" /> -->
          <div class="load-fail">{{ $t("live.newLoading") }}</div>
          <!-- <div class="loading-bar">
            <div class="loading-bar-mask"></div>
          </div> -->
          <div class="loading_animate">
            <img
              class="animate"
              :src="require('@/assets/live/point.svg')"
              alt=""
            />
          </div>
        </div>
        <!-- 加载失败 -->
        <div class="player-loading" v-if="refreshFlag">
          <!-- <div class="player-loading" v-if="false"> -->
          <!-- <img class="load-fail-img" src="./img/Load-Fail.png" alt /> -->
          <div class="load-fail">{{ $t("player.signalWeak") }}</div>
          <div class="load-fail-btn">
            <div class="again-btn" style="margin-right: 0rem" @click="refresh">
              {{ $t("player.flesh") }}
            </div>
            <!-- <div class="again-btn again-btn1" style="margin-left: 0.15rem">切换线路</div> -->
          </div>
        </div>
      </div>
      <!-- 未开播 -->
      <div class="no-player" v-if="detail && detail.status == 0">
        <img src="./img/live-off.png" alt="" />
        <div class="or-reday reday">{{ $t("pcLive.notStart") }}</div>
      </div>
      <div class="player-pause" v-if="detail && detail.status == 3">
        <img :src="detail.anchor_avatar" alt="" />
        <div>{{ $t("player.leave") }}</div>
      </div>
      <div class="player-pause" v-if="detail && detail.status == 4">
        <img :src="detail.anchor_avatar" alt="" />
        <div class="player-pause-text">- {{ $t("player.end") }} -</div>
        <div>{{ $t("player.endTip") }}</div>
      </div>
      <div
        class="iframe-box"
        :class="mathInfo.sport_id == 2 ? 'iframeBbox' : ''"
        v-if="detail && detail.status == 5"
      >
        <iframe
          :src="detail.pull_url || detail.pull_flv_url"
          :style="mathInfo.sport_id == 2 ? 'min-height: 426px' : ''"
        ></iframe>
      </div>
    </div>
    <div v-if="isEnterRoom" class="enter-room" @click.self="enterRoom"></div>
    <!-- 视频播放 -->
    <video id="liveMatchesTwoPlayer" style="width: 100%; height: 100%"></video>
    <div v-show="!showBoxFlag && isReplay" id="liveMatchesTwoPlayer1"></div>
    <vue-danmaku
      v-show="!isHomePlay"
      @click.native="togglePlay()"
      ref="danmu"
      :danmus="messageList"
      :top="danmuColumn"
      :speeds="speed"
      use-slot
      class="danmu"
    >
      <template slot="dm" slot-scope="{ danmu }">
        <!-- <div :class="['danmu-text', userInfo.id == danmu.user_id ? 'danmu-active' : '']" :style="{ color: colorInput[danmu.textColor] }"> -->
        <div
          :id="danmu.id"
          v-show="
            !danmu.isSpeaker &&
            !danmu.isColorful &&
            isDanmuShow &&
            danmu.type !== 'attentAnchor'
          "
          class="danmu-text"
          :style="{
            color: danmu.textColor === '#333333' ? '#FFFFFF' : danmu.textColor,
          }"
        >
          {{ danmu.content }}
        </div>
        <div v-show="danmu.isSpeaker" class="danmu-text-speaker">
          <img src="./img/speaker-danmu.png" alt="" />
          <div class="">{{ danmu.from_client_name }}:</div>
          <div style="color: #ffe600; margin-left: 0.08rem">
            {{ danmu.content }}
          </div>
        </div>
        <div
          :id="danmu.id"
          class="colorfull-popup-list"
          v-show="
            danmu.isColorful && danmu.textColor == item.color && isDanmuShow
          "
          v-for="(item, index) in colorfulText"
          :key="index"
        >
          <img :src="item.a" alt="" />
          <div
            class="mid"
            :class="index == 1 ? 'mid2' : index == 2 ? 'mid3' : ''"
          >
            {{ danmu.content }}
          </div>
          <img :src="item.b" alt="" />
        </div>
      </template>
    </vue-danmaku>
    <div
      class="live-ad"
      v-show="liveAd !== '' && !isHomePlay"
      :class="{ 'slide-in-ad': showLabel || paused }"
      ref="liveAd"
    >
      <span class="announce_move">{{ liveAd }}</span>
    </div>

    <player-control
      key="player-control2"
      ref="playerControl"
      :idx="2"
      :title="detail.title"
      :detail="detail"
      :anchorid="detail.anchorid"
      @refresh="refresh"
      @togglePlay="togglePlay"
      v-if="controlFlag && detail.platform !== 3"
      :class="{ 'slide-in': showLabel || paused }"
      @fullscreen="fullscreen"
      :paused="paused"
      @show="alwaysShow"
      @hide="toggleControl"
      @changeVol="changeVol"
      @toggleVol="toggleVol"
      @toggleDan="toggleDan"
      :volume="volume"
      @qualityUrl="changeVideoQuality"
      :qualityName="qualityMenu"
      :currentQuality="currentQuality"
      :full="full"
      :bulletFlag="bulletFlag"
      :isHomePlay="isHomePlay"
      :isSHowProgress="isSHowProgress"
      :loadingFlag="loadingFlag"
    ></player-control>

    <!--切换清晰度-->
    <el-dialog
      ref="videoQualityDialog"
      :visible.sync="showLoginTip"
      width="355px"
      top="30vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="true"
      custom-class="tip-dialog"
      :append-to-body="true"
    >
      <div class="tip-content flex-column flex-middle-only">
        <h3 class="text-title">{{ $t("pcLive.tip") }}</h3>
        <!--        <p style="line-height: .22rem;">登录后开启与主播互动</p>-->
        <p>
          <span style="color: rgba(208, 45, 84, 1)">{{
            $t("pcLive.login")
          }}</span
          >{{ $t("pcLive.afterLogin") }}
        </p>
        <el-button class="login-btn flex-middle" @click="loginNow">{{
          $t("pcLive.loginNow")
        }}</el-button>
        <p
          style="color: #999; font-size: 0.14rem; cursor: pointer"
          @click="closeLoginTip"
        >
          {{ $t("pcLive.ignore") }}
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import PlayerControl from "../../components/player-control/liveMatchesTwoPlayerControl";
import axios from "axios";
import { post } from "../../util/http";
import { mapMutations, mapState } from "vuex";
import { getDate } from "../../util/time";
import flvjs from "flv.js";
// import DPlayer from "dplayer";
import vueDanmaku from "vue-danmaku";
import TCPlayer from "tcplayer.js";
// import "tcplayer.js/dist/tcplayer.min.css";

const maxWatchingTime = 3 * 60;

export default {
  components: {
    PlayerControl,
    vueDanmaku,
  },
  watch: {
    detail: {
      handler(n, o) {
        if (this.player) {
          // this.loadFail = true;
          this.destroyPlayer();
        }
        this.$nextTick(() => {
          if (this.detail.animation == 1) {
            this.detail.status = 5;
            this.controlFlag = false;
          } else {
            this.init();
          }
        });
      },
      immediate: true,
    },
    playerStatus(val, o) {
      if (val == 1) {
        this.showBoxFlag = false;
        this.detail.status = 1;
        if (this.player) {
          this.player.loadByUrl(this.playerUrl);
        }
      }
      if (val == 2) {
        this.showBoxFlag = true;
        this.detail.status = 0;
      }
      if (val == 0) {
        this.showBoxFlag = true;
        this.detail.status = 3;
      }
      if (val == 255) {
        this.showBoxFlag = true;
        this.detail.status = 0;
      }
    },
    deleteMessageId(newVal) {
      document.getElementById(newVal)?.parentNode.remove();
    },
  },

  props: {
    detail: {
      type: Object,
      default() {
        return null;
      },
    },
    hotLives: {
      type: Array,
      default() {
        return [];
      },
    },
    // danmus: {
    //   type: Array,
    //   default() {
    //     return [];
    //   },
    // },

    isAnchor: {
      type: Boolean,
      default: false,
    },
    bulletFlag: {
      type: Boolean,
      default: true,
    },
    isHomePlay: {
      type: Boolean,
      default: false,
    },
    mathInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    isEnterRoom: {
      type: Boolean,
      default: true,
    },

    websock: {
      type: WebSocket,
      default: null,
    },
  },
  computed: {
    ...mapState([
      "userInfo",
      "appConfig",
      "showBarrage",
      "showLogin",
      "liveAd",
      "playerStatus",
      "deleteMessageId",
      "messageList",
    ]),
    hotList() {
      let num = this.hotLives.length;
      if (num > 3) {
        return this.hotLives.slice(0, 3);
      } else {
        return this.hotLives;
      }
    },
    qualityMenu() {
      const arr = [];
      if (this.detail.pull_url) {
        return arr;
      }
      if (this.detail.pull_flv_url) {
        arr.push({
          id: 2,
          name: this.$t("player.UC"),
          url: this.detail.pull_flv_url,
        });
      }

      if (this.detail.pull_flv_url2) {
        arr.push({
          id: 1,
          name: this.$t("player.SD"),
          url: this.detail.pull_flv_url2,
        });
      }
      return arr;
    },
  },
  data() {
    return {
      wrapHeights: "",
      paused: true,
      volume: 50,
      cacheVolume: 50,
      showLoginTip: false,
      showLabel: false,
      showBoxFlag: true,
      loadingFlag: true,
      refreshFlag: false,
      loadFail: false,

      removeImage: false,
      player: null,
      playerUrl: "",
      currentQuality: { id: 2, name: this.$t("player.UC") },
      controlFlag: true,
      full: false,
      watchTimer: null,
      hlsPlayer: null,
      flvPlayer: null,
      welcomeText: "",
      ws: null,
      cursorVisible: true,
      speed: 80,
      danmuColumn: 20,
      startDanmuWidth: "",
      showPlayer: true,
      colorInput: ["#ffffff", "#0098FF", "#5669FF", "#F34F4F", "#FFA400"],
      colorfulText: [
        {
          a: require("./img/colorful1-start.png"),
          b: require("./img/colorful1-end.png"),
          color: "#113BD0",
        },
        {
          a: require("./img/colorful2-start.png"),
          b: require("./img/colorful2-end.png"),
          color: "#E41EB1",
        },
        {
          a: require("./img/colorful3-start.png"),
          b: require("./img/colorful3-end.png"),
          color: "#FF6B00",
        },
      ],
      isDanmuShow: true,
      danmus: [],
      isReplay: false,
      tcPlayer: null,
      isSHowProgress: false, //是否显示进度条
    };
  },
  onIdle() {
    if (this.full) {
      document.body.style.cursor = "none";
      this.showLabel = false;
    }
  },
  onActive() {
    if (this.full) {
      document.body.style.cursor = "auto";
      this.showLabel = true;
    }
  },

  mounted() {
    this.startDanmuWidth = this.$refs.danmu.$el.offsetWidth;
    this.isDanmuShow = localStorage.getItem("bulletChat")
      ? JSON.parse(localStorage.getItem("bulletChat"))
      : true;
    // 由于全屏状态下无法监听 onkeydown 事件，所以通过 onresize 来监听 ESC 退出全屏事件
    // window.onresize = this.dobounce(() => {
    //   this.full = this.checkFullScreen();
    // });
  },
  destroyed() {
    this.destroyPlayer();
    if (this.watchTimer) {
      clearInterval(this.watchTimer);
      this.watchTimer = null;
    }
  },
  methods: {
    ...mapMutations([
      "changeUserInfo",
      "toggleBarrage",
      "changeWrapHeight",
      "toggleLogin",
    ]),

    setAttributes(el, attrs) {
      for (var key in attrs) {
        el.setAttribute(key, attrs[key]);
      }
    },

    closeLoginTip() {
      localStorage.setItem(`w_r_${this.detail.anchorid}`, "0");
      this.showLoginTip = false;
    },

    init() {
      this.initialQuality();
      // this.showBoxFlag = true;
      this.loadingFlag = true;
      // this.refreshFlag = false;
      // this.loadFail = false;
      console.log("测试", this.detail.status, this.detail.pull_flv_url);

      if (this.detail.status == 1 || this.currentQuality.url) {
        if (this.currentQuality.url) {
          this.controlFlag = true;
        }
        this.createPlayer(this.currentQuality.url);
      } else {
        this.controlFlag = false;
      }
      //
      if (this.detail.pull_url && this.detail.pull_url.includes("http")) {
        this.isSHowProgress = true;
      }
    },

    startStoreWatchTime() {
      if (this.watchTimer) {
        clearInterval(this.watchTimer);
        this.watchTimer = null;
      }

      this.watchTimer = setInterval(() => {
        const key = `w_r_${this.$route.params.id}`;
        let watchTime = Number(localStorage.getItem(key) ?? 0);
        watchTime += 1;

        localStorage.setItem(key, watchTime.toString());
        if (
          !/^\/liveMatchesTwo\/\d+/.test(this.$route.path) ||
          this.userInfo.id
        ) {
          clearInterval(this.watchTimer);
          this.watchTimer = null;
          return;
        }

        this.controlFlag = true;
        if (watchTime > maxWatchingTime) {
          // clearInterval(this.watchTimer)
          // this.watchTimer = null

          // 如果当前是超清
          // if (this.currentQuality.id !== 1) {
          //   this.changeVideoQuality({ id: 1, name: '标清', url: this.detail.pull_flv_url2 })
          //   localStorage.setItem('quality', '1')
          // }

          // 未显示登陆弹框的时候 弹出提示
          if (!this.showLogin && !this.showLoginTip) {
            this.showLoginTip = true;
          }
          console.log(key, "===========>");
          localStorage.setItem(key, "0");
        }
      }, 1000);
    },

    initialQuality() {
      console.log("initialQuality", this.detail);
      // const key = `w_r_${this.$route.params.id}`
      localStorage.setItem("quality", "2");
      let urlFinal = "";
      if (typeof window !== "undefined") {
        const isWindows = /windows/i.test(navigator.userAgent);
        if (isWindows) {
          urlFinal = this.detail.pull_flv_url;
        } else {
          urlFinal = this.detail.pull_url;
        }
      }

      this.currentQuality = {
        id: 2,
        name: this.$t("player.UC"),
        url: urlFinal,
      };
      this.startStoreWatchTime();
      // 进直播间 判断是否有登陆
      // 1 已登陆 播放超清视频
      // 2 未登陆 并且该直播间累计观看小于5分钟。 播放超清视频，累计观看5分钟后 提示登陆，并切换到标清
      // if (this.userInfo.id) {
      // localStorage.removeItem('quality')
      // localStorage.removeItem(key)
      // this.currentQuality = { id: 2, name: '超清', url: this.detail.pull_flv_url }
      // } else {
      // const watchTime = Number(localStorage.getItem(key) ?? 0)
      // const quality = localStorage.getItem('quality')
      // if (watchTime >= maxWatchingTime || quality === '1') {
      //   localStorage.setItem('quality', '1')
      //   this.currentQuality = { id: 1, name: '标清', url: this.detail.pull_flv_url2 }
      // } else {
      //   localStorage.setItem('quality', '2')
      //   this.currentQuality = { id: 2, name: '超清', url: this.detail.pull_flv_url }
      //   this.startStoreWatchTime()
      // }
      // }
    },

    loginNow() {
      this.showLoginTip = false;
      this.toggleLogin();
    },

    hotCount(hot) {
      if (hot < 10000) {
        return hot;
      } else {
        const num = hot / 10000;
        return `${num.toFixed(1) + 0.1}w`;
      }
    },

    alwaysShow() {
      clearTimeout(this.timer);
      this.showLabel = true;
    },
    onMousemove(e) {
      if (this.full) {
        if (e.clientX < 5) {
          document.body.style.cursor = "none";
          this.showLabel = false;
        } else {
          document.body.style.cursor = "auto";
          this.showLabel = true;
        }
      } else {
        document.body.style.cursor = "auto";
        this.showLabel = true;
      }
    },

    enterRoom() {
      if (!this?.detail?.anchorid) return;
      const path = this.$route?.path || "";
      if (path.indexOf("/liveMatchesTwo/") > -1) return;
      this.$router.push({
        path: `/liveMatchesTwo/${this.detail.anchorid}`,
      });
    },

    toggleControl() {
      this.showLabel = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.showLabel = false;
      }, 1);
    },

    // 切换清晰度
    changeVideoQuality(obj) {
      console.log("切换清晰度: ", obj);
      // this.destroyPlayer()
      if (obj.url) {
        this.currentQuality = obj;
        localStorage.setItem("quality", obj.id);
        this.destroyPlayer();

        setTimeout(() => {
          this.createPlayer(this.currentQuality.url);
        }, 20);
      }
    },

    checkUrl(url = "") {
      if (!url) {
        return;
      }
      axios
        .request({
          url: url,
          timeout: 5000,
        })
        .then((res) => {
          console.log("axios success", res);
          let { status = "" } = res;
          if (status != 200) {
            this.showBoxFlag = true;
            this.refreshFlag = true;
            this.loadingFlag = false;
          }
          // this.removeImage = true;
        })
        .catch((e) => {
          this.showBoxFlag = true;
          this.refreshFlag = true;
          this.loadingFlag = false;
        });
    },

    createPlayer(url) {
      this.playerUrl = url;
      console.log("platform::", this.detail.platform);
      if (this.detail.platform === 3) {
        //回放视频
        this.isReplay = true;
        this.player = new window.HlsJsPlayer({
          id: "liveMatchesTwoPlayer1",
          url: url,
          autoplay: true,
          // videoInit: true,
          width: "100%",
          height: "100%",
          playbackRate: [0.5, 0.75, 1, 1.25, 1.5, 2],
          keyShortcut: "on",
          keyShortcutStep: {
            currentTime: 5, //播放进度调整步长，默认10秒
          },
        });
        this.player.on("ready", () => {
          console.log("player on ready");
          document
            .getElementById("liveMatchesTwoPlayer1")
            .appendChild(this.$refs.danmu.$el);
          document
            .getElementById("liveMatchesTwoPlayer1")
            .appendChild(this.$refs.liveAd);
        });
      } else {
        this.isReplay = false;
        // this.player = new Aliplayer(
        //   {
        //     id: "liveMatchesTwoPlayer",
        //     source: url,
        //     // source: "https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8",
        //     isLive: true,
        //     controlBarVisibility: "never",
        //   },
        //   function (player) {
        //     console.log("The player is created. 0", player);
        //   }
        // );
        this.player = new TCPlayer("liveMatchesTwoPlayer", {
          sources: [
            {
              src: url,
            },
          ],
          webrtcConfig: {
            connectRetryCount: 9999,
            // fallbackUrl,
          },
          autoplay: true,
          licenseUrl:
            "https://license.vod-control.com/license/v2/1323112987_1/v_cube.license",
          controls: false,
        });

        this.player.ready(() => {
          console.log("player on ready");
          document
            .getElementById("liveMatchesTwoPlayer")
            .appendChild(this.$refs.danmu.$el);
          document
            .getElementById("liveMatchesTwoPlayer")
            .appendChild(this.$refs.playerControl.$el);
          // document.getElementById("liveMatchesTwoPlayer").appendChild(this.$refs.videoQualityDialog.$el);
          document
            .getElementById("liveMatchesTwoPlayer")
            .appendChild(this.$refs.liveAd);
        });

        // this.player.on("ready", () => {
        //   console.log("player on ready");
        //   document
        //     .getElementById("liveMatchesTwoPlayer")
        //     .appendChild(this.$refs.danmu.$el);
        //   document
        //     .getElementById("liveMatchesTwoPlayer")
        //     .appendChild(this.$refs.playerControl.$el);
        //   // document.getElementById("liveMatchesTwoPlayer").appendChild(this.$refs.videoQualityDialog.$el);
        //   document
        //     .getElementById("liveMatchesTwoPlayer")
        //     .appendChild(this.$refs.liveAd);
        // });
      }

      this.player.on("pause", () => {
        // console.log("pause");
        this.paused = true;
      });

      this.player.on("canplay", () => {
        console.log("canplay_chester");
        this.showBoxFlag = false;
        this.loadingFlag = false;
        this.refreshFlag = false;
      });

      this.player.on("playing", () => {
        console.log("play");
        console.log(
          "canplay_chester",
          "playing",
          this.showBoxFlag,
          this.isReplay
        );
        this.paused = false;
      });

      this.player.on("fullscreenchange", () => {
        if (this.player.isFullscreen()) {
          this.full = true;
        } else {
          this.full = false;
        }
      });
      // this.player.on("cancelFullScreen", () => {
      //   this.full = false;
      // });

      this.player.on("error", (e) => {
        console.log("播放出错error", e);
        this.showBoxFlag = true;
        this.loadingFlag = false;
        this.refreshFlag = true;
      });
    },

    destroyPlayer() {
      if (this.player && this.detail.platform === 3) {
        this.player.destroy();
        console.log("销毁播放器");
        this.player = null;
        this.showBoxFlag = true;
      } else {
        this.player?.dispose();
        console.log("销毁播放器");
        this.player = null;
        this.showBoxFlag = true;
      }
    },
    refresh() {
      location.reload();
    },

    togglePlay() {
      if (this.paused) {
        this.player?.play();
        this.paused = false;
      } else {
        this.player?.pause();
        this.paused = true;
      }
    },
    fullscreen(full = false) {
      this.full = full;
      if (full) {
        // this.quan();
        // this.player.requestFullscreen();
        // this.player.fullScreen.request();
        // this.handleFullScreen();
        this.player.requestFullscreen()();
        console.log(this.player.fullscreenService.getIsFullScreen);
        this.full = true;
        this.$refs.danmu.$el.style.width = window.innerWidth + "px";
        this.$refs.danmu.resize();
      } else {
        console.log(this.startDanmuWidth);
        this.controlFlag = true;
        // this.player.exitFullscreen();
        // this.player.fullScreen.cancel();
        // this.handleExitFullScreen();
        this.player.exitFullscreen();
        this.full = false;
        this.$refs.danmu.$el.style.width = this.startDanmuWidth + "px";
        this.$refs.danmu.resize();
      }
    },

    toggleVol() {
      if (this.volume > 0) {
        this.cacheVolume = this.volume;
        this.volume = 0;
        // this.player.volume(0);
        this.player.volume(0);
        return;
      }
      this.volume = this.cacheVolume || 0;
      // this.player.volume(this.volume / 100);
      this.player.volume(this.volume / 100);
    },
    changeVol(vol) {
      this.volume = vol;
      // console.log("this.volume", this.volume);
      // this.player.volume(this.volume / 100);
      this.player.volume(this.volume / 100);
    },

    toggleDan(val) {
      // 弹幕的
      if (val) {
        this.isDanmuShow = true;
        // this.$refs.danmu.show();
      } else {
        this.isDanmuShow = false;
        // this.$refs.danmu.hide();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .tip-dialog {
  background: linear-gradient(158.56deg, #e3faff 0%, #ffffff 42.59%);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.05);
  border-radius: 0.2rem;

  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}

.tip-content {
  font-size: 0.16rem;
  color: #333;
  padding: 0.24rem 0;

  .text-title {
    font-size: 0.2rem;
    line-height: 0.28rem;
    margin-bottom: 0.16rem;
  }

  .login-btn {
    width: 2.16rem;
    height: 0.44rem;
    background: linear-gradient(91.39deg, #ff3465 5.61%, #cf2d54 90.03%);
    box-shadow: 0 4px 8px rgba(48, 185, 188, 0.2);
    border-radius: 6px;
    padding: 0;
    color: #fff;
    margin: 0.2rem auto 0.12rem;
  }
}

::v-deep .vjs-control-bar {
  display: none;
}

::v-deep .tcp-right-click-popup-menu {
  display: none;
}

.danmu {
  width: 100%;
  height: 100%;
  // width: 7rem;
  // height: 5rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

.danmu-text {
  font-weight: 500;
  font-size: 0.24rem;
  text-shadow: 0px 0px 2px #000000;
}

.danmu-text-speaker {
  background: linear-gradient(
    89.79deg,
    rgba(0, 130, 250, 0.9) 0.22%,
    rgba(9, 240, 255, 0.9) 99.34%
  );
  box-shadow: 0px 0px 12px rgba(0, 155, 189, 0.3);
  backdrop-filter: blur(4px);
  border-radius: 0.47rem;
  height: 0.47rem;
  display: flex;
  align-items: center;
  padding-left: 0.12rem;
  padding-right: 0.2rem;

  img {
    width: 0.56rem;
    height: 0.51rem;
    margin-right: 0.1rem;
  }
}

.colorfull-popup-list {
  display: flex;
  align-items: center;
  cursor: pointer;

  img {
    width: 0.3rem;
    height: 0.5rem;
  }

  .mid {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 0.7rem;
    height: 0.5rem;
    background: url("./img/colorful1-mid.png");
    background-size: 100% 100%;
    color: #ffffff;
    font-size: 0.22rem;
  }

  .mid2 {
    background: url("./img/colorful2-mid.png");
    background-size: 100% 100%;
  }

  .mid3 {
    background: url("./img/colorful3-mid.png");
    background-size: 100% 100%;
  }
}

.danmu-active {
  border: 0.01rem solid #fff;
  padding: 0.05rem;
}

.subscribe {
  position: absolute;
  left: 50%;
  bottom: 50%;
  width: 100%;
  padding: 0 0.25rem;

  transform: translate3d(0, 100%, 0);
  transition: all 0.3s;
  z-index: 99;
  width: 100px;
  height: 100px;
  background-color: red;
}

.liveMatchesTwoPlayerClass {
  width: 100%;
  height: 100%;
  // background-color: rgba(0, 0, 0, 0.8);
  // opacity: 1;
  background: url("./img/player_bg.png") center 0 no-repeat;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;

  .slide-in {
    transform: translate3d(0, 0, 0);
  }

  .player-main {
    width: 100%;
    // height: 100%;
    position: relative;
    // background-color: rgba(0,0,0,.8);
    display: flex;
    justify-content: center;
    align-items: center;

    // z-index: 1;
    &.fixed {
      background-color: rgba(0, 0, 0, 1);
      opacity: 1;
      position: fixed;
      left: 0px;
      top: 0px;
      right: 0px;
      bottom: 0px;
      z-index: 100;
    }

    .player-load {
      display: flex;
      justify-content: center;
      align-items: center;

      .logo {
        width: 100%;
        z-index: 1;
        display: block;
      }

      .player-loading {
        height: 100%;
        color: #fff;
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;

        .loading-logo {
          // width: 2.87rem;
          // height: 0.85rem;
          width: 2rem;
        }

        .load-fail {
          font-size: 0.14rem;
          color: #ffffff;
          // line-height: 20px;
          margin-top: 0.2rem;
          margin-bottom: 0.33rem;
        }

        .loading-bar {
          width: 2.3rem;
          height: 0.02rem;
          background: linear-gradient(
            90deg,
            #02a1f9 26.04%,
            #29f19c 54.17%,
            #02a1f9 78.12%
          );
          background-size: 400% 400%;
          animation: Gradient 2s ease infinite;
          position: relative;

          .loading-bar-mask {
            width: 2.3rem;
            height: 0.02rem;
            background: linear-gradient(
              90deg,
              rgba(0, 0, 0, 0.5),
              rgba(0, 0, 0, 0),
              rgba(0, 0, 0, 0.5)
            );
            position: absolute;
            top: 0;
            left: 0;
          }
        }

        @keyframes Gradient {
          0% {
            background-position: 0% 50%;
          }

          50% {
            background-position: 100% 50%;
          }

          100% {
            background-position: 0% 50%;
          }
        }

        // .loadingCla {
        //   font-size: 28px;
        // }
        // .loading-spinner {
        //   background-image: url("./img/loading.svg");
        //   background-repeat: no-repeat;
        //   background-size: 40px 40px;
        //   height: 40px;
        //   width: 40px;
        //   margin: 0 auto;
        //   background-position: center;
        //   animation: loading-rotate 2s linear infinite;
        // }

        .load-fail-img {
          width: 1.24rem;
          height: 1.24rem;
        }

        .load-fail-btn {
          display: flex;
        }

        .again-btn {
          // background-image: linear-gradient(-45deg, #12db98 0%, #0cbe82 100%);
          width: 1.1rem;
          height: 0.38rem;
          border: 0.01rem solid rgba(255, 56, 56, 1);
          border-radius: 0.38rem;
          font-size: 0.14rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 500;
          color: rgba(255, 56, 56, 1);
          // margin-left: 0.3rem;
          cursor: pointer;
          z-index: 3;
        }

        .again-btn1 {
          background: linear-gradient(101.98deg, #ff3838 10.8%, #d02d54 95.33%);
          border: 0;
          color: #fff;
        }
      }
    }

    .player-pause {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;
      font-size: 0.14rem;

      img {
        width: 0.9rem;
        height: 0.9rem;
        border-radius: 0.9rem;
        border: 0.01rem solid rgba(255, 56, 56, 1);
        margin-bottom: 0.2rem;
      }

      .player-pause-text {
        color: rgba(255, 56, 56, 1);
        margin-bottom: 0.12rem;
      }
    }

    .iframe-box {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      background: transparent url("./img/football_bg.png");
      background-size: 100% 100%;
    }

    .iframeBbox {
      background: transparent url("./img/basketball_bg.png") no-repeat;
      background-size: 100% 100%;
    }

    iframe {
      min-width: 800px;
      min-height: 452px;
      border: 0.1rem solid rgba(255, 255, 255, 0.2);
      border-radius: 0.2rem 0.2rem 0rem 0rem;
    }

    .no-player {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;
      font-size: 0.14rem;

      img {
        width: 1.24rem;
        height: 1.24rem;

        margin-bottom: 0.2rem;
      }

      // position: absolute;
      // top: 50%;
      // transform: translateY(-50%);
      // width: 100%;

      // .reday {
      //   margin: 0 auto;
      //   color: #fff;
      //   text-align: center;
      // }
      // .or-reday {
      //   font-size: 18px;
      //   line-height: 25px;
      //   color: #ffffff;
      //   font-weight: 500;
      // }
      // .other-reday {
      //   font-size: 14px;
      //   color: #ffffff;
      //   line-height: 20px;
      //   margin-top: 40px;
      //   margin-bottom: 16px;
      // }
      // .other-items {
      //   display: flex;
      //   width: 100%;
      //   overflow: hidden;
      //   padding: 0 24px;
      //   box-sizing: border-box;
      //   justify-content: center;

      //   .item {
      //     width: 271px;
      //     height: 230px;
      //     background: #ffffff;
      //     box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
      //     border-radius: 16px;
      //     margin-right: 16px;
      //     cursor: pointer;

      //     .item-img {
      //       width: 100%;
      //       height: 152px;
      //       border-radius: 16px 16px 0 0;
      //       background-size: 100% auto;
      //       background-repeat: no-repeat;
      //       background-position: center center;
      //     }
      //     .item-bot {
      //       padding: 12px 16px;
      //       box-sizing: border-box;
      //       .item-bot-img {
      //         cursor: pointer;
      //         width: 30px;
      //         height: 30px;
      //         border-radius: 50%;
      //         margin-right: 6px;
      //         overflow: hidden;
      //         display: flex;
      //         align-items: center;
      //         > img {
      //           width: 100%;
      //           height: 100%;
      //         }
      //       }
      //       .item-bot-title {
      //         width: 100%;
      //         line-height: 22px;
      //         white-space: nowrap;
      //         overflow: hidden;
      //         text-overflow: ellipsis;
      //         font-size: 16px;
      //         color: #333333;
      //         font-weight: 500;
      //         margin-bottom: 8px;
      //       }

      //       .item-bot-info {
      //         width: 100%;
      //         display: flex;
      //         align-items: center;
      //       }
      //       .item-bot-avatar {
      //         width: 24px;
      //         height: 24px;
      //         border-radius: 50%;
      //         margin-right: 8px;
      //       }

      //       .item-bot-nickname {
      //         flex: 1;
      //         white-space: nowrap;
      //         overflow: hidden;
      //         text-overflow: ellipsis;
      //       }
      //       .item-bot-num {
      //         font-size: 14px;
      //         color: #666666;
      //       }
      //       .item-bot-icon {
      //         width: 16px;
      //         height: 16px;
      //         margin-right: 4px;
      //         margin-left: 16px;
      //       }
      //     }
      //   }
      //   :last-child {
      //     margin-right: 0;
      //   }
      // }
    }
  }

  .enter-room {
    width: 100%;
    height: 525px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }

  .live-ad {
    width: 100%;
    height: 0.4rem;
    // background: linear-gradient(90deg, rgba(196, 43, 26, 0.6) 0%, rgba(47, 17, 167, 0.6) 51.69%, rgba(11, 52, 118, 0.6) 100%), rgba(0, 0, 0, 0.6);
    // backdrop-filter: blur(2px);
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 500;
    font-size: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 0.2rem;
    // transform: translate3d(0, -100%, 0);
    transition: all 0.3s;
    z-index: 5;
    position: absolute;
    bottom: 0;
  }

  .slide-in-ad {
    transform: translate3d(0, -0.52rem, 0);
  }

  .announce_move {
    // animation: myMove 15s linear infinite; // 重点，定义动画
    // animation-fill-mode: forwards;
    // white-space: nowrap;
    // display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    line-height: 0.4rem;
    color: #ffba39;
    text-shadow: 0px 0px 4px #000000;
  }
}

/*文字无缝滚动*/
// @keyframes myMove {
//   0% {
//     transform: translateX(2.52rem);
//   }
//   100% {
//     transform: translateX(-5.73rem);
//   }
// }
.loading_animate {
  margin-top: 0.08rem;
  width: 2.76rem;
  height: 0.08rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  background-image: url("~@/assets/live/bgAnimate.png");

  .animate {
    width: 0.8rem;
    height: 0.8rem;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-50%, -51%);
    animation: pointAnimate 1s linear infinite;
  }
}

@keyframes pointAnimate {
  0% {
    transform: translate(-50%, -51%);
  }

  100% {
    transform: translate(2.36rem, -51%);
  }
}
</style>
